/*
 * Drop down menu
 */
'use strict';

jQuery($ => {
	/*
	 * If the submenu is off screen add offscreen class.
	 */
	$(".gecko-header-desktop__navigation .menu-item").on('mouseenter', function (e) {
	if ($('.menu > .menu-item > .sub-menu').length) {
		$('.menu > .menu-item > .sub-menu').each(function(){
			var el = $(this);
			var offset = el.offset();
			var elRight = offset.left + el.outerWidth();
			var windowWidth = $(window).width();
			var isEntirelyVisible = (elRight <= windowWidth);
			if (!isEntirelyVisible) {
				$(this).addClass('offscreen');
			}
		});
	}
	});

});
